import React from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import * as moment from 'moment';
import OrderProp from '../../shop/propTypes/orderProp';
import translate from '../../../commonComponents/translate';
import List from '../../../commonComponents/lists/ClientSideList';
import CurrencyProp from '../../profile/propTypes/currencyProp';

function PendingOrdersSection({ t, pendingOrders, currencies }) {
  const orders = pendingOrders.map(order => ({
      avatar: order.owner.image?.thumb || '/images/no_user.png',
      client: order.owner.username,
      number: order.number,
      price: (order.total / 100).toFixed(2) + (currencies.find(c => c.code === 'EUR')?.symbol || '€'),
      date: moment.utc(order.createdAt).format('DD MMM, YY'),
      status: order.status,
      download_url: order.invoice?.link || null,
      _id: order._id,
    }));

  const columns = [
    {
      field: 'client',
      title: t('shop.client'),
      textAlign: 'center',
      sortable: false,
      template(order) {
        return renderToStaticMarkup(<>
          <img className="user-avatar-img mr-4" alt="useravatar" src={order.avatar} />
          <span>{order.client}</span>
                                    </>);
      },
    },
    {
      field: 'number',
      title: t('orders_list_number'),
      textAlign: 'center',
      sortable: 'desc',
      template(order) {
        return renderToStaticMarkup(<a className="pending-orders-number" href={`/shop/order/${order._id}`}>{order.number}</a>);
      },
    },
    {
      field: 'price',
      title: t('orders_list_price'),
      textAlign: 'center',
      sortable: false,
    },
    {
      field: 'date',
      title: t('orders_list_date'),
      textAlign: 'center',
    },
    {
      field: 'status',
      title: t('orders_list_status'),
      textAlign: 'center',
      template(order) {
        const status = {
          pending: { title: 'shop.pending', class: 'status-pending' },
          pending_payment: { title: 'shop.pending_payment', class: 'status-pending-payment' },
          processing: { title: 'shop.processing', class: 'status-processing' },
        };
        return renderToStaticMarkup(
          <span className={`status-label ${status[order.status].class}`}>{t(status[order.status].title)}</span>,
        );
      },
    },
    {
      title: '',
      field: 'Invoice',
      textAlign: 'center',
      sortable: false,
      template(order) {
        return renderToStaticMarkup(
          <a target="_blank" rel="noreferrer" className="m-link" href={order.download_url}>
            <i className="fa fa-download" />
          </a>,
        );
      },
    },
  ];

  return (
    <div className="m-portlet m-portlet--rounded m-portlet--rounded-force">
      <div className="m-portlet__head pending-orders-header">
        <div className="m-portlet__head-caption">
          <div className="m-portlet__head-title py-2">
            <h3 className="m-portlet__head-text">{t('inbox_pending_orders')}</h3>
          </div>
        </div>
      </div>
      <div className="m-portlet__body pending-orders-container">
        <List
          id="pendingOrdersList"
          loading={false}
          data={orders}
          columns={columns}
        />
      </div>
    </div>
  );
}

PendingOrdersSection.propTypes = {
  t: PropTypes.func.isRequired,
  pendingOrders: PropTypes.arrayOf(PropTypes.shape(OrderProp.propType)).isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType)).isRequired,
};

export default translate(PendingOrdersSection);
